import React from "react";
import { ListIcon } from "@phosphor-icons/react";

/**
 * Route skeleton for the phone Chats hub (#11742 round 3). Mirrors the
 * real bar's leading affordance (the hamburger — the hub is the surface
 * chat's back chains terminate on) so the control doesn't pop in after
 * load, then the search field and a column of row blocks.
 */
const ChatsHubSkeletonLoader: React.FC = () => {
  return (
    <div className="w-full h-full flex flex-col bg-white rounded-lg overflow-hidden">
      <div className="px-4 py-3 flex justify-between">
        <div className="flex items-center gap-2 text-gray-800 font-semibold text-lg">
          <span
            aria-hidden="true"
            className="md:hidden flex-none w-[30px] h-[30px] -ml-1 grid place-items-center text-gray-400"
          >
            <ListIcon size={18} />
          </span>
          <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
      </div>
      <div className="px-4 pb-2">
        <div className="h-11 bg-gray-200 rounded-xl animate-pulse"></div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden px-4 pt-2">
        <ChatsHubRowsSkeleton />
      </div>
    </div>
  );
};

/**
 * The row-column pulse block alone — shared with the hub's own in-component
 * loading state so the two loading anatomies cannot drift.
 */
export const ChatsHubRowsSkeleton: React.FC = () => (
  <div className="space-y-2">
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <div key={i} className="py-3">
        <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse mb-2"></div>
        <div className="h-3 w-1/3 bg-gray-200 rounded animate-pulse"></div>
      </div>
    ))}
  </div>
);

export default ChatsHubSkeletonLoader;
